"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BT003_SUBSCRIPTION_BASKET_ERROR = exports.BT003_DEFAULT_ERROR = void 0;
var Context_1 = __importDefault(require("../../Enums/Context"));
var GroupDeliveryDayErrors_1 = require("../DeliveryPoint/GroupDeliveryDayErrors");
var Errors_1 = __importDefault(require("../../Constants/Wordings/Errors"));
exports.BT003_DEFAULT_ERROR = {
    buttons: [
        {
            label: 'Modifier mon point de retrait', route: {
                name: "account-dlp-search-step1-".concat(Context_1.default.Basket), params: {
                    type: 'point-relais'
                }
            },
        }
    ],
    handle: function (resp) {
        var _a, _b;
        var gdd = (_b = (_a = resp.data) === null || _a === void 0 ? void 0 : _a.basket) === null || _b === void 0 ? void 0 : _b.groupDeliveryDay;
        return { text: gdd ? (0, GroupDeliveryDayErrors_1.getGddError)(gdd) : Errors_1.default.DEFAULT };
    },
};
exports.BT003_SUBSCRIPTION_BASKET_ERROR = {
    buttons: [
        {
            label: 'Modifier mon point de retrait', route: { name: 'tunnel-delivery-type-step1' },
        }
    ],
    handle: function (resp) {
        var _a, _b;
        var gdd = (_b = (_a = resp.data) === null || _a === void 0 ? void 0 : _a.basket) === null || _b === void 0 ? void 0 : _b.groupDeliveryDay;
        return { text: gdd ? (0, GroupDeliveryDayErrors_1.getGddError)(gdd) : Errors_1.default.DEFAULT };
    },
};
exports.default = {
    default: exports.BT003_DEFAULT_ERROR, 'TemporaryCustomerApi.addBasketSubscription': exports.BT003_SUBSCRIPTION_BASKET_ERROR,
    'UserApi.addSubscriptionToSubscriptionBasket': exports.BT003_SUBSCRIPTION_BASKET_ERROR,
};
//# sourceMappingURL=BT003Handler.js.map